<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'AwardsLainnya',

    metaInfo: { title: 'Penghargaan Perusahaan' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'awards-others',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'awardsothers',
      },
    },
  }
</script>
